import { atom } from 'jotai';
import { toZonedTime } from 'date-fns-tz';
import { addDays, format } from 'date-fns';

export const capacityAdultAtom = atom<number>(2);
export const capacityChildAtom = atom<number>(0);
export const capacityChildAgesAtom = atom<number[]>([]);
export const prevCheckinDateAtom = atom<string>();
export const prevCheckoutDateAtom = atom<string>();
export const checkInDateAtom = atom<string>();
export const checkOutDateAtom = atom<string>();

/** 국내숙소 체크인/체크아웃 날짜 및 인원 상태를 관리하는 atom */
export const localCheckIOCapacityAtom = atom((get) => {
  const today = toZonedTime(new Date(), 'Asia/Seoul'); // KST 기준으로 오늘
  return {
    checkInDate: get(checkInDateAtom) || format(today, 'yyyy-MM-dd'),
    checkOutDate: get(checkOutDateAtom) || format(addDays(today, 1), 'yyyy-MM-dd'),
    capacityAdult: get(capacityAdultAtom) || 2,
    capacityChild: get(capacityChildAtom) || 0,
    capacityChildAges: get(capacityChildAgesAtom) || [],
    prevCheckinDate: get(prevCheckinDateAtom),
    prevCheckoutDate: get(prevCheckoutDateAtom),
  };
});
